/** Simple shared flag so admin tabs can warn before leaving unsaved work. */

let dirty = false;
let pageLabel = "";

export function setAdminDirty(isDirty, label = "") {
  dirty = Boolean(isDirty);
  pageLabel = isDirty ? String(label || "") : "";
}

export function clearAdminDirty() {
  dirty = false;
  pageLabel = "";
}

export function isAdminDirty() {
  return dirty;
}

export function getAdminDirtyLabel() {
  return pageLabel;
}
